import Logo from '@/assets/SinoTransPFS.jpg';

export const PROJECTNAME = "中外运普菲斯";
export const LOGO = Logo;